import * as angular from "angular";
import { CModelRepo as cModelRepo, CModelRepo, Locality } from "../cmodel.repo";
import { CModelUtilities as cModelUtilities } from "../../common/cmodel.utilities";
import { CModelItem as cModelItem, CModelItem } from "../cmodelitem";

class CModelMauritiusController implements angular.IOnInit {
  public equityCModelData: Array<cModelItem>;
  public equityCModelDataSnapShot: Array<cModelItem>;
  public fixedIncomeCModelData: Array<cModelItem>;
  public preciousMetalCModelData: Array<cModelItem>;
  public cashCModelData: Array<cModelItem>;
  public cModel: any;
  public originalCModel: any;
  public cModelTotal: number;
  public equitiesList: any;
  public sectorsList: any;
  public geographiesList: any;

  public equityTracker: any;

  /** @ngInject */
  constructor(
    private cModelRepo: cModelRepo,
    private $filter: angular.IFilterFunction,
    private cModelUtilities: cModelUtilities,
    private $rootScope: angular.IRootScopeService,
    private $mdDialog: angular.material.IDialogService,
    private $state: angular.ui.IStateService
  ) {}

  $onInit() {
    this.loadContext();
  }

  public loadContext() {
    let that = this;

    that.UpdateCModelData();
    that.getEquityList();
    that.getSectorList();
    that.getGeographyList();
    this.equityTracker = 3;
  }

  public cancel() {
    this.$state.go("root.cmodel");
    return;
  }

  // Update the CModelData for all 4 asset classes:
  UpdateCModelData() {
    this.cModelRepo.getCModel().then((val) => {
      this.originalCModel = angular.copy(val.data);
      this.loadCModel(val.data);
    });
  }

  getSEMDEXPercentageTotal() {
    if (this.equityCModelData != null) {
      return this.equityCModelData.reduce((total, item) => {
        if (!item.isDeleted) {
          return total + item.semdexPercentage;
        } else {
          return total;
        }
      }, 0);
    }
  }
  getModelPercentageTotal() {
    if (this.equityCModelData != null) {
      return this.equityCModelData.reduce((total, item) => {
        if (!item.isDeleted) {
          return total + item.modelPercentage;
        } else {
          return total;
        }
      }, 0);
    }
  }

  getEquityList() {
    let that = this;

    that.cModelRepo.getEquityItemsList(Locality.Local).then((val) => {
      that.equitiesList = val.data;
    });
  }

  getSectorList() {
    let that = this;

    that.cModelRepo.getSectorsList().then((val) => {
      that.sectorsList = val;
    });
  }

  getGeographyList() {
    let that = this;

    that.cModelRepo.getGeographiesList().then((val) => {
      that.geographiesList = val;
    });
  }

  // Add a line item:
  public addLineItem(assetClassIndicator: string) {
    var newItem = new cModelItem();

    switch (assetClassIndicator) {
      case "Equity": {
        newItem.assetClass = "Equity";
        this.equityCModelData.unshift(newItem);
        this.equityCModelData[0].isNew = true;
        break;
      }
      case "Fixed Income": {
        newItem.assetClass = "Fixed Income";
        this.fixedIncomeCModelData.unshift(newItem);
        this.fixedIncomeCModelData[0].isNew = true;
        break;
      }
      case "Commodities": {
        newItem.assetClass = "Commodities";
        this.preciousMetalCModelData.unshift(newItem);
        this.preciousMetalCModelData[0].isNew = true;
        break;
      }
      case "Cash": {
        newItem.assetClass = "Cash";
        this.cashCModelData.unshift(newItem);
        this.cashCModelData[0].isNew = true;
        break;
      }
    }

    this.updateModel();
  }

  // Filter line items to show:
  public filterLineItems(lineItem) {
    return lineItem.isDeleted !== true;
  }

  // Mark line items as deleted:
  public deleteLineItem(security) {
    let that = this;
    that.$mdDialog
      .show(
        this.$mdDialog
          .confirm()
          .clickOutsideToClose(true)
          .title("Warning")
          .textContent(
            "Are you sure you want to remove " +
              security.name +
              " from the model?"
          )
          .theme("primary ")
          .ok("Yes")
          .cancel("Cancel")
      )
      .then(
        // This code runs when confirm is clicked.
        () => {
          var filtered = this.$filter("filter")(this.equityCModelData, {
            security: security,
          });
          if (filtered.length) {
            filtered[0].isDeleted = true;
          }
          this.updateModel();
        }
      );
  }

  // Cancel all changes:
  public cancelChanges() {
    let that = this;
    that.cModel = angular.copy(that.originalCModel);

    this.loadCModel(that.cModel);
  }

  // Save all changes:
  public saveTable(assetClassIndicator: string) {
    let that = this;
    var results = [];

    // Create a new variable for the modified CModel:
    let modifiedCModel = that.cModel;

    // Clear the C Model Items array so that we can add all the new & edited items to the list:
    modifiedCModel["cModelItems"].length = 0;

    switch (assetClassIndicator) {
      case "Equity":
        // For every line item in the equity C Model data set:
        for (var i = this.equityCModelData.length; i--; ) {
          var item = that.equityCModelData[i];

          //actually delete item
          if (item.isDeleted) {
            this.equityCModelData.splice(i, 1);
          }

          //mark as not new
          if (item.isNew) {
            item.isNew = false;
          }
        }
        break;
      case "Cash":
        // For every line item in the equity C Model data set:
        for (var i = this.cashCModelData.length; i--; ) {
          var item = that.cashCModelData[i];

          //actually delete item
          if (item.isDeleted) {
            this.cashCModelData.splice(i, 1);
          }

          //mark as not new
          if (item.isNew) {
            item.isNew = false;
          }
        }
        break;
    }

    // Add the modified line items to the modified CModel (in the server's CModelItemDTO format):
    for (var i = 0; i < this.equityCModelData.length; i++) {
      var lineItem = this.equityCModelData[i];
      modifiedCModel["cModelItems"].push(lineItem.getCModelItemDTOData());
    }

    for (var i = 0; i < this.cashCModelData.length; i++) {
      var lineItem = this.cashCModelData[i];
      modifiedCModel["cModelItems"].push(lineItem.getCModelItemDTOData());
    }
    modifiedCModel.cModelId++;
    // Send the modified C Model to the Server to be saved in the DB then read to update the model.
    that.cModelRepo
      .saveModifiedCModel(modifiedCModel)
      .then((data) => that.UpdateCModelData());
  }

  // Update Stage Model Values
  public updateModel() {
    var total = 0;

    // Calculate the NAV:
    for (var i = this.equityCModelData.length; i--; ) {
      var item = this.equityCModelData[i];
      if (!item.isDeleted) {
        total += item.portfolioValue;
      }
    }

    this.cModelTotal = total;

    // Calculate the model percentage per line item:
    for (var i = this.equityCModelData.length; i--; ) {
      var item = this.equityCModelData[i];
      if (!item.isDeleted) {
        item.modelPercentage = (100 * item.portfolioValue) / total;
      }
    }
  }

  updateLineItem(lineItem: any) {
    if (lineItem != null) {
      lineItem.portfolioValue = this.getPortfolioValue(lineItem);
    }

    this.updateModel();
  }

  private loadCModel(model) {
    let that = this;
    that.equityCModelData = new Array<cModelItem>();
    that.fixedIncomeCModelData = new Array<cModelItem>();
    that.preciousMetalCModelData = new Array<cModelItem>();
    that.cashCModelData = new Array<cModelItem>();
    // Set the C Model data:
    that.cModel = model;
    that.cModelTotal = that.getCModelTotal(that.cModel);
    // Set the list of C Model Items:
    let itemsList = that.cModel["cModelItems"];

    // Add each item to its matching asset class list:
    for (var item of itemsList) {
      let cModelLineItem = new cModelItem(item);

      switch (cModelLineItem.assetClass) {
        case "Equity": {
          that.equityCModelData.push(cModelLineItem);
          break;
        }
        case "Fixed Income": {
          that.fixedIncomeCModelData.push(cModelLineItem);
          break;
        }
        case "Commodities": {
          that.preciousMetalCModelData.push(cModelLineItem);
          break;
        }
        case "Cash": {
          that.cashCModelData.push(cModelLineItem);
          break;
        }
      }
    }
  }

  //
  // Utility Methods:
  //
  public formatCurrency(currencyCode: string) {
    return this.cModelUtilities.formatCurrency(currencyCode);
  }

  public getPortfolioValue(lineItem: any) {
    return this.cModelUtilities.getPortfolioValue(lineItem);
  }

  public getDelta(lineItem: any) {
    return this.cModelUtilities.getDelta(lineItem);
  }

  public isDeltaOverThreshold(lineItem: any) {
    return Math.abs(this.cModelUtilities.getDelta(lineItem)) > 3;
  }

  public getCModelTotal(cModel: any) {
    return this.cModelUtilities.getCModelTotal(cModel);
  }

  public getCModelToDate() {
    if (this.cModel) {
      var fromDate = new Date(this.cModel.dateCreated);
      return new Date().setDate(fromDate.getDate() + 7);
    }
  }

  updatePriceToLatest = () => {
    this.equityCModelData.forEach((c) => (c.price = c.lastPrice));
  };
}

export const cModelMauritius: angular.IComponentOptions = {
  template: require("./cmodel.mauritius.html"),
  controller: CModelMauritiusController,
};



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodel.mauritius/cmodel.mauritius.ts